import React from 'react';
import { AdminProvider, useAdmin } from '../contexts/AdminContext';
import AdminLogin from './admin/AdminLogin';
import AdminDashboard from './admin/AdminDashboard';
import LoadingSpinner from './LoadingSpinner';

function AdminContent() {
  const { adminUser, loading } = useAdmin();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!adminUser) {
    return <AdminLogin />;
  }

  return <AdminDashboard />;
}

export default function AdminPage() {
  return (
    <AdminProvider>
      <AdminContent />
    </AdminProvider>
  );
}